import { EventBets, Slip } from 'types/Slip';
import { SlipEvent } from 'types/SlipEvent';
import { comboSum, systemLabel } from 'helpers/systemBets';

export const mapHttpResponse = (data: any[]): Slip[] => {
  data.forEach((slip) => {
    slip.numberOfBets = 0;
    slip.event_bets = [];
    slip.maxCoefficient = 1;
    const events: SlipEvent[] = Array.isArray(slip.ticket_events)
      ? slip.ticket_events
      : [];
    events.forEach((event: SlipEvent) => {
      ++slip.numberOfBets;
      const eventIndex = slip.event_bets?.findIndex(
        (x: EventBets) => x.event.eventId === event.event_id
      );
      const bet = {
        betName: event.bet_name,
        status: event.status,
        oddCustomId: event.odd_custom_id,
        odd: {
          name: event.odd_name,
          header: event.odd_header,
          handicap: event.odd_handicap,
          odds: event.odd_value,
        },
      };

      if (eventIndex === -1) {
        slip.event_bets.push({
          event: {
            eventId: event.event_id,
            away: event.away_team,
            home: event.home_team,
            status: event.status,
            resultAtCreation: event.result_at_creation,
            resultAtCreationSecond: event.result_at_creation_second ?? null,
            currentResult: event.current_result ?? null,
            currentResultSecond: event.current_result_second ?? null,
            goalEvents: Array.isArray(event.goal_events)
              ? event.goal_events
              : [],
            isLive: event.is_live_event,
            result: {
              homeGoals: event.home_goals,
              awayGoals: event.away_goals,
            },
            time: event.time,
          },
          bets: [bet],
        });
      } else {
        slip.event_bets[eventIndex].bets.push(bet);
      }
    });
    // Combinations, as the server settles them: one pick from every match
    // each (on a system, from every `size` of the matches); the best a
    // ticket can do is the best pick of every match.
    slip.systemSizes = parseSystem(slip.system);
    slip.combination =
      slip.event_bets.length > 0
        ? Math.round(
            comboSum(
              slip.event_bets.map((x: EventBets) => x.bets.length),
              slip.systemSizes
            )
          )
        : 0;
    slip.event_bets.forEach((x: EventBets) => {
      const best = Math.max(
        ...x.bets.map((b) =>
          typeof b.odd.odds === 'number' && Number.isFinite(b.odd.odds)
            ? b.odd.odds
            : 1
        )
      );
      slip.maxCoefficient *= best;
    });
  });
  return data;
};

/** A ticket's system sizes ("7,8" -> [7, 8]); null for an ordinary one. */
export const parseSystem = (system: unknown): number[] | null => {
  if (typeof system !== 'string' || !system.trim()) return null;
  const sizes = system
    .split(',')
    .map((x) => Number(x.trim()))
    .filter((k) => Number.isInteger(k) && k > 0);
  return sizes.length > 0 ? sizes : null;
};

/**
 * What kind of ticket it is, as My bets shows it: "Combination (1)",
 * "Combination Multi (9)" or "System 7/9 (36)".
 */
export const slipKindLabel = (
  slip: Slip,
  t: (key: string) => string
): string => {
  if (slip.systemSizes) {
    return `${t('system_label')} ${systemLabel(
      slip.systemSizes,
      slip.event_bets.length
    )} (${slip.combination})`;
  }
  return `${t('combination_label')} ${
    slip.combination === 1 ? '(1)' : `Multi (${slip.combination})`
  }`;
};
